import React from 'react'
import BasicModal from '../BasicModal'
import AddChannelCodeForm from '../../forms/AddChannelCodeForm'

const AddChannelCodeModal = ({ isVisible, data, onClose, onSubmit }) => {
   return (
      <BasicModal
         title='Добавить канал'
         isVisible={isVisible}
         onClose={onClose}
      >
         <AddChannelCodeForm
            data={data}
            onSubmit={onSubmit}
         />
      </BasicModal>
   )
}

export default AddChannelCodeModal